import { FailIcon } from '@tlx/atlas';
import React, { Children } from 'react';

export function InputError({
    children,
    errors,
    className,
}: {
    children: React.ReactNode;
    errors?: string | string[];
    width?: number;
    className?: string;
}) {
    const child = Children.only(children);
    let innerErrors;
    if (typeof errors === 'string') {
        innerErrors = [errors];
    }
    if (Array.isArray(errors)) {
        innerErrors = errors;
    }
    const type = (child as React.ReactElement<{ type: string }>).props.type;

    const hasErrors = innerErrors?.some((e) => e);

    return (
        <div>
            <div
                className={`${className ?? ''} tsk-input--normalizeSize ${
                    hasErrors ? 'tsk-input--error' : ''
                } ${type === 'date' ? 'tsk-input__date-picker' : ''}`}
            >
                {child}
            </div>
            {hasErrors && (
                <div className="atl-flex atl-gap-8 atl-mt-8">
                    <FailIcon size="small" className="atl-text-red-100" />
                    {innerErrors?.map((err, index) => (
                        <div key={index} className={'tsk-input__errorMessage'}>
                            {err}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
